export interface MapBoxFeatureCollection {
  type: 'FeatureCollection';
  attribution: string;
  features: MapBoxFeature[];
}

export interface MapBoxGeometry {
  type: 'Point'; // TODO: add other types
  coordinates: [number, number]; // [longitude, latitude]
}

export interface MapBoxFeature {
  type: 'Feature';
  id: string;
  geometry: MapBoxGeometry;
  properties: {
    context: {
      address: {
        address_number: string;
        mapbox_id: string;
        name: string;
        street_name: string;
      };
      country: {
        country_code: string;
        country_code_alpha_3: string;
        name: string;
        translations: {
          ru: {
            language: 'ru';
            name: string;
          };
        };
        // ...
      };
      place: {
        name: string;
        // ...
      };
      postcode: {
        name: string;
        // ...
      };
      region: {
        name: string;
        region_code: string;
        region_code_full: string;
        // ...
      };
      street: {
        name: string;
        // ...
      };
    };
    coordinates: {
      accuracy: 'rooftop';
      latitude: number;
      longitude: number;
    };
    feature_type: 'address';
    full_address: string;
    mapbox_id: string;
    name: string;
    name_preferred: string;
    place_formatted: string;
    routable_points: [
      {
        latitude: number;
        longitude: number;
        name: 'default';
      },
    ];
  };
}

export interface Location {
  latitude: number;
  longitude: number;
}

// use to send to BE
export interface Address {
  // MapBoxFeature.properties.context.country.
  // country_code: "BY"
  // country_code_alpha_3: "BLR"
  country_code: string;
  // MapBoxFeature.properties.full_address
  full_address: string;
  // MapBoxFeature.properties.coordinates.latitude
  // MapBoxFeature.properties.coordinates.longitude
  location: Location;
  // MapBoxFeature.properties.context.country.name
  country: string;
  // MapBoxFeature.properties.context.region.name
  state_province: string;
  // MapBoxFeature.properties.context.place.name
  city: string;
  // MapBoxFeature.properties.context.street.name
  street: string;
  // MapBoxFeature.properties.context.post_code.name
  post_code: string;
}

// comes from BE
export interface AddressResponse {
  id: string;
  country_code: string;
  country: string;
  state_province: string;
  city: string;
  street: string;
  post_code: string;
  latitude: number;
  longitude: number;
  full_address: string;
}

export const convertResponseToAddress = (addressResponse: AddressResponse): Address => {
  const address: any = {};

  // skip id

  address.location = {
    latitude: Number(addressResponse.latitude),
    longitude: Number(addressResponse.longitude),
  };

  // Always include string fields (use empty string if null/undefined to avoid validation errors)
  address.country = addressResponse.country || '';
  address.country_code = addressResponse.country_code || '';
  address.full_address = addressResponse.full_address || '';
  address.state_province = addressResponse.state_province || '';
  address.city = addressResponse.city || '';
  address.street = addressResponse.street || '';
  address.post_code = addressResponse.post_code || '';

  return address;
};

export interface Option<T> {
  label: string;
  value: T;
}
